import axios from "axios";
import { headersProvider } from "../apiHelpers";
import constants from "../constants";

export const getUserTasks = () =>
  axios.get(`${constants.apiHost}/tasks/my-tasks`, {
    headers: headersProvider(),
  });

export const getResourceTasks = ({ parentResource, parentResourceId, page }) =>
  axios.get(`${constants.apiHost}/tasks/list`, {
    params: {
      page,
      parent: parentResource,
      parentId: parentResourceId,
    },
    headers: headersProvider(),
  });

export const updateTask = ({ taskId, status }) =>
  axios.put(
    `${constants.apiHost}/tasks/edit-task/${taskId}`,
    {
      status,
    },
    {
      headers: headersProvider(),
    },
  );

export const createTaskApi = ({ taskData }) =>
  axios.post(
    `${constants.apiHost}/tasks/create-task`,
    {
      ...taskData,
    },
    {
      headers: headersProvider(),
    },
  );

export const getTaskDetails = ({ taskId }) =>
  axios.get(`${constants.apiHost}/tasks/details/${taskId}`, {
    headers: headersProvider(),
  });

export const addTaskRemark = ({ taskId, remark }) =>
  axios.post(
    `${constants.apiHost}/tasks/add-remark`,
    {
      taskId,
      remark,
    },
    {
      headers: headersProvider(),
    },
  );

export const getSelfTasks = ({ page, assignedToId }) =>
  axios.get(`${constants.apiHost}/tasks/self-tasks`, {
    params: {
      page,
      assignedToId,
    },
    headers: headersProvider(),
  });

export const MyTasks = ({ page, statusTab }) =>
  axios.get(
    `${constants.apiHost}/tasks/self-tasks?page=${page}&tabname=${statusTab}`,
    {
      headers: headersProvider(),
    },
  );
export const TeamTasks = ({ page, statusTab }) =>
  axios.get(
    `${constants.apiHost}/tasks/team-tasks?page=${page}&tabname=${statusTab}`,
    {
      headers: headersProvider(),
    },
  );

export const tasksAnalytics = ({ month }) =>
  axios.get(`${constants.apiHost}/tasks/analytics/${month}`, {
    headers: headersProvider(),
  });

export const getTaskAssignedEmails = () =>
  axios.get(`${constants.apiHost}/tasks/assigned-emails`, {
    headers: headersProvider(),
  });

export const updateCompleteFlag = ({ taskId, isCompleted }) =>
  axios.post(
    `${constants.apiHost}/tasks/complate-update/${taskId}`,
    {
      isCompleted,
    },
    {
      headers: headersProvider(),
    },
  );
export const AgreementManagerAnalytics = () =>
  axios.get(`${constants.apiHost}/agreement/agreementManagerAnalytics`, {
    headers: headersProvider(),
  });
